export const DndIcon = ({ ...props }) => {
  return (
    <div className="d-flex gap-1 align-items-center" {...props}>
      <div className="dnd-icon"></div>
      <div className="dnd-icon"></div>
    </div>
  );
};
